export enum HealthAnalysisJourneyStepEnum {
    IN_STOCK='IN_STOCK',
    SENT='SENT',
    COLLECTED='COLLECTED',
    RECEIVED='RECEIVED',
    PROCESSING_IN_LABORATORY='PROCESSING_IN_LABORATORY',
    BIOINFORMATIC='BIOINFORMATIC',
    COMPLETED='COMPLETED',
    RECOLLECTED='RECOLLECTED'
}
